export const focFieldRegex = {
    checkbox: /foc_action_(\d+)_checked/,
    date: /foc_gap_action_detail_(\d+)_(\d+)_(\d+)_(date)/,
    system_id: /foc_gap_action_detail_(\d+)_(\d+)_(\d+)_(system_id)/,
    answer: /foc_gap_action_detail_(\d+)_(\d+)_(\d+)_(answer)/,
};

export const qualityFieldRegex = {
    checkbox: /quality_measure_detail_(\d+)_(\d+)_checked/,
    date: /quality_measure_detail_(\d+)_(\d+)_(\d+)_(date)/,
    answer: /quality_measure_detail_(\d+)_(\d+)_(\d+)_(answer$)/,
    answer2: /quality_measure_detail_(\d+)_(\d+)_(\d+)_(answer2$)/,
};

export function focVarsFromField(fieldId: string) {
    if (fieldId === 'submitted') {
        return {
            actionId: null,
            detailId: null,
            detailSystemId: null,
            fieldType: 'submitted',
        };
    }

    // Find field match
    let fieldMatch = fieldId.match(focFieldRegex.checkbox);
    if (fieldMatch?.[0]) {
        return {
            actionId: parseInt(fieldMatch[1]),
            detailId: null,
            detailSystemId: null,
            fieldType: 'checkbox',
        };
    }

    fieldMatch = fieldId.match(focFieldRegex.date);
    if (!fieldMatch?.[0]) {
        fieldMatch = fieldId.match(focFieldRegex.answer);
    }
    if (!fieldMatch?.[0]) {
        fieldMatch = fieldId.match(focFieldRegex.system_id);
    }
    if (!fieldMatch?.[0]) {
        return null; // No matches
    }

    return {
        actionId: parseInt(fieldMatch[1]),
        detailId: parseInt(fieldMatch[2]),
        detailSystemId: parseInt(fieldMatch[3]),
        fieldType: fieldMatch[4],
    };
}

export function qualityVarsFromField(fieldId: string) {
    if (fieldId === 'submitted') {
        return {
            detailId: null,
            systemId: null,
            dataType: null,
            fieldType: 'submitted',
        };
    }

    // Find field match
    let fieldMatch = fieldId.match(qualityFieldRegex.checkbox);
    if (fieldMatch?.[0]) {
        return {
            detailId: parseInt(fieldMatch[1]),
            systemId: null,
            dataType: null,
            fieldType: 'checkbox',
        };
    }

    fieldMatch = fieldId.match(qualityFieldRegex.date);
    if (!fieldMatch?.[0]) {
        fieldMatch = fieldId.match(qualityFieldRegex.answer);
    }
    if (!fieldMatch?.[0]) {
        fieldMatch = fieldId.match(qualityFieldRegex.answer2);
    }
    if (!fieldMatch?.[0]) {
        return {
            detailId: null,
            systemId: null,
            dataType: null,
            fieldType: null,
        };
    }

    return {
        detailId: parseInt(fieldMatch[1]),
        systemId: parseInt(fieldMatch[2]),
        dataType: parseInt(fieldMatch[3]),
        fieldType: fieldMatch[4],
    };
}
